<template>
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle opacity="0.5" cx="10.5001" cy="9.99996" r="8.33333" stroke="currentColor" stroke-width="1.5" />
        <path d="M13 10L10.5 10M10.5 10L8 10M10.5 10L10.5 7.5M10.5 10L10.5 12.5" stroke="currentColor" stroke-width="1.5"
            stroke-linecap="round" />
    </svg>
</template>